import { render, staticRenderFns } from "./EditPartner.vue?vue&type=template&id=b17349aa&scoped=true"
import script from "./EditPartner.vue?vue&type=script&lang=js"
export * from "./EditPartner.vue?vue&type=script&lang=js"
import style0 from "./EditPartner.vue?vue&type=style&index=0&id=b17349aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17349aa",
  null
  
)

export default component.exports